import { useEffect, useState } from 'react';
import { ComboBox, Inline } from '@airbus/components-react';
import { useColumnContextAPI } from '../../../shared/context/GetAllColumnContext';
import { useConfigContext } from '../../../shared/context/ConfigContext';
import { getScreenGridIdDetails } from '../services/getScreenGridIdDetails';
import { getFormOrderDropDown } from '../services/getFormOrderDropDown';
import { getColumnGroupDropDown } from '../services/getColumnGroupDropDown';
import { getHeaderScreenDetails } from '../../getHeaderScreenDetails';

type DropdownItem = {
  label: string;
  value: number | string;
};

export default function ComboBoxForScreens({ setTableId, screenGridId }) {
  //setTableId
  const { allDropdowns, updateCustomConfig, setAllDropdowns } = useColumnContextAPI();
  const { configSchema } = useConfigContext();
  const [optionsFirstDrop, setOptionsFirstDrop] = useState([]);
  const [selectedFirstDropValue, setSelectedFirstDropValue] = useState();
  const [selectedFirstDropLabel, setSelectedFirstDropLabel] = useState();
  const [optionsSecondDrop, setOptionsSecondDrop] = useState([]);
  const [selectedSecondDropValue, setSelectedSecondDropValue] = useState();
  const [selectedSecondDropLabel, setSelectedSecondDropLabel] = useState();
  const isDuplicateLabel = (accu: DropdownItem[], label: string): boolean => {
    return accu.some((v: DropdownItem) => v.label === label);
  };

  const uniqueByLabelReducer = (accu: DropdownItem[], item: DropdownItem): DropdownItem[] => {
    if (!isDuplicateLabel(accu, item.label)) {
      accu.push(item);
    }
    return accu;
  };
  useEffect(() => {
    const fetchScreens = async () => {
      const screensDetails = await getHeaderScreenDetails(screenGridId, configSchema);
      const screenList = screensDetails[`${configSchema}_mbd_screens`].map((item) => {
        return { label: item.screen_display_name_en, value: item.id };
      });
      setSelectedFirstDropLabel(screenList[1]?.label);
      setOptionsFirstDrop(screenList);
      setSelectedFirstDropValue(screenList[1]?.value);
    };
    fetchScreens();
  }, []);

  useEffect(() => {
    if (selectedFirstDropValue) {
      const screenGridIdWhere = {
        items: [
          {
            field: 'screen_id',
            id: 1,
            operator: '=',
            value: selectedFirstDropValue,
          }
        ],
        logicOperator: 'and',
      };
      getScreenGridIdDetails(screenGridId, configSchema, screenGridIdWhere).then((res) => {
        if (res) {
          const newOptionsSecond = res?.[`${configSchema}_mbd_screen_to_data_grids`]?.map((v) => {
            return { value: v.id, label: v.mbd_data_grid.data_grid_internal_name };
          });
          setOptionsSecondDrop(newOptionsSecond);
          setTableId(newOptionsSecond[0]?.value);
          setSelectedSecondDropValue(newOptionsSecond[0]?.value);
          setSelectedSecondDropLabel(newOptionsSecond[0]?.label);
        }
      });
    }
  }, [selectedFirstDropValue]);
  useEffect(() => {
    const fetchData = async () => {
      if (selectedSecondDropValue) {
        const formOrderWhere = {
          items: [
            {
              field: 'screen_grid_id',
              id: 1,
              operator: 'equals',
              value: selectedSecondDropValue,
            },
            {
              field: 'form_order_no',
              id: 2,
              operator: 'isNotEmpty',
              value: false,
            },
          ],
          logicOperator: 'and',
        };
        const res = await getFormOrderDropDown(screenGridId, configSchema, formOrderWhere);
        const colGroupWhere = {
          items: [
            {
              field: 'screen_grid_id',
              id: 1,
              operator: 'equals',
              value: selectedSecondDropValue,
            },
            {
              field: 'attr_group_id',
              id: 2,
              operator: 'isNotEmpty',
              value: false,
            },
          ],
          logicOperator: 'and',
        };
        const colGroupRes = await getColumnGroupDropDown(screenGridId, configSchema, colGroupWhere);
        const colGroupAllData = colGroupRes.map((v) => {
          return { value: v.attr_group_id, label: v.mbd_attribute_group.attribute_group_name_en };
        });
        const colGroupDropDown = colGroupAllData.reduce(uniqueByLabelReducer, []);

        const response = res.map((v) => {
          return { label: v.form_order_no, value: v.form_order_no };
        });
        setAllDropdowns({
          ...allDropdowns,
          form_order_no: response,
          col_group_id: colGroupDropDown,
        });
      }
    };
    fetchData();
  }, [selectedSecondDropValue, selectedSecondDropLabel]);
  useEffect(() => {
    if (selectedSecondDropValue) {
      updateCustomConfig({
        AdditionalFilterQuery: `screen_grid_id:{_eq:${selectedSecondDropValue}} ,attr_managed_by_admin:{_eq:true}`,
      });
    }
  }, [allDropdowns]);

  const handleChangeFirst = (value) => {
    if (value) {
      setTableId(value?.value);
      setSelectedFirstDropValue(value?.value);
      setSelectedFirstDropLabel(value?.label);
    }
  };
  const handleChangeSecond = (value) => {
    if (value) {
      setTableId(value?.value);
      setSelectedSecondDropValue(value?.value);
      setSelectedSecondDropLabel(value?.label);
    }
  };
  return (
    <Inline alignY='center' align='center' spacing='2-x'>
      <div className='w-250'>
        <ComboBox
          hideClear
          options={optionsFirstDrop}
          onChange={(obj) => handleChangeFirst(obj)}
          value={
            selectedFirstDropValue
              ? { label: selectedFirstDropLabel, value: selectedFirstDropValue }
              : null
          }
        />
      </div>
      <div className='w-250'>
        <ComboBox
          hideClear
          options={optionsSecondDrop}
          onChange={(obj) => handleChangeSecond(obj)}
          value={
            selectedSecondDropValue
              ? { label: selectedSecondDropLabel, value: selectedSecondDropValue }
              : null
          }
        />
      </div>
    </Inline>
  );
}
